import React, { useState } from 'react'
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
import { useDispatch } from 'react-redux';
import getNotification from '../../Redux/Action/action';

function UbLbTable({ objective, originalsetublboriginal, sampledataset2, originalset2, handleoriginaldataset2change, handlesampledataset2change }) {

  const hidingvariablelist = ExceptionVariables?.hiddenvariables;
  const [addminuspercentagelb, setaddminuspercentagelb] = useState([])
  const [addminuspercentageub, setaddminuspercentageub] = useState([])
  const [edit, setedit] = useState([])
  const dispatch = useDispatch()
  const table2edit = (e, variableIndex, type) => {
    const updatedDataset = [...sampledataset2];
    const enteredvalue = e.target.value || 0;

    if (type === "lb") {
      let arr = [...addminuspercentagelb];
      const percentageChange = ((enteredvalue - originalsetublboriginal[variableIndex].a_point) / originalsetublboriginal[variableIndex].a_point * 100)?.toFixed(2);
      arr[variableIndex] = percentageChange === "Infinity" ? 0 : percentageChange;
      updatedDataset[variableIndex].a_point = enteredvalue;
      setaddminuspercentagelb(arr);
    }
    else if (type === "ub") {
      let arr = [...addminuspercentagelb];
      if (objective === 'Maintain Spends to Maximize Sales' || objective === 'Maintain Sales and Minimize Spends') {
        const percentageChange = ((enteredvalue - originalsetublboriginal[variableIndex].c_point) / originalsetublboriginal[variableIndex].c_point * 100)?.toFixed(2);
        arr[variableIndex] = percentageChange === "Infinity" ? 0 : percentageChange;
        updatedDataset[variableIndex].c_point = enteredvalue;
      }
      else {
        const percentageChange = ((enteredvalue - originalsetublboriginal[variableIndex].d_point) / originalsetublboriginal[variableIndex].d_point * 100)?.toFixed(2);
        arr[variableIndex] = percentageChange === "Infinity" ? 0 : percentageChange;
        updatedDataset[variableIndex].d_point = enteredvalue;
      }
      setaddminuspercentageub(arr);
    }

    handlesampledataset2change(updatedDataset);
  };

  const table2editpercetnagebasis = (e, variableIndex, type) => {
    const updatedDataset = [...sampledataset2];
    const enteredValue = parseFloat(e.target.value) || 0;
    if (false) {
      dispatch(
        getNotification({
          message: "Entered value must be between -25% and 25%.",
          type: "danger",
        })
      );
      return;
    }

    // Helper function to update percentage arrays
    const updatePercentage = (array, index, value, isLowerLimit) => {
      const updatedArray = [...array];
      updatedArray[index] = value;
      isLowerLimit
        ? setaddminuspercentagelb(updatedArray)
        : setaddminuspercentageub(updatedArray);
    };

    // Update the respective limits
    if (type === "lb") {
      updatePercentage(addminuspercentagelb, variableIndex, enteredValue, true);

      updatedDataset[variableIndex].a_point = Number(
        originalsetublboriginal[variableIndex].a_point * (1 + enteredValue / 100))?.toFixed(2);
    } else if (type === "ub") {
      updatePercentage(addminuspercentageub, variableIndex, enteredValue, false);
      if (objective === 'Maintain Spends to Maximize Sales' || objective === 'Maintain Sales and Minimize Spends') {
        updatedDataset[variableIndex].c_point = Number(
          originalsetublboriginal[variableIndex].c_point * (1 + enteredValue / 100))?.toFixed(2);
      }
      else {
        updatedDataset[variableIndex].d_point = Number(
          originalsetublboriginal[variableIndex].d_point * (1 + enteredValue / 100))?.toFixed(2);
      }

    }

    // Update the original dataset
    handlesampledataset2change(updatedDataset);
    // handlesampledataset2change(updatedDataset)
  };

  const handlecancel = (variableIndex) => {
    const updatedDataset1 = [...sampledataset2];
    const updatedDataset2 = [...originalset2];

    let arr1 = [...addminuspercentagelb]
    let arr2 = [...addminuspercentageub]

    const isMaintainObjective = objective === "Maintain Spends to Maximize Sales" || objective === "Maintain Sales and Minimize Spends";

    const lowerLimitBase = originalsetublboriginal[variableIndex].a_point || 1;
    const upperKey = isMaintainObjective ? "c_point" : "d_point";

    const upperLimitBase = originalsetublboriginal[variableIndex][upperKey] || 1;

    // Calculate percentage changes
    let percentageChangelb = ((updatedDataset1[variableIndex].lower_limit - originalsetublboriginal[variableIndex].lower_limit) / lowerLimitBase) * 100;

    let percentageChangeub = ((updatedDataset1[variableIndex][upperKey] - originalsetublboriginal[variableIndex][upperKey]) / upperLimitBase) * 100;

    // Ensure finite values and format
    percentageChangelb = isFinite(percentageChangelb) ? percentageChangelb.toFixed(0) : 0;
    percentageChangeub = isFinite(percentageChangeub) ? percentageChangeub.toFixed(0) : 0;
    setaddminuspercentagelb(arr1)
    setaddminuspercentageub(arr2)
    if (isMaintainObjective) {
      updatedDataset1[variableIndex].c_point = updatedDataset2[variableIndex].c_point;
    }
    else {
      updatedDataset1[variableIndex].d_point = updatedDataset2[variableIndex].d_point;
    }
    updatedDataset1[variableIndex].a_point = updatedDataset2[variableIndex].a_point;
    handlesampledataset2change(updatedDataset1)
  }

  const handleupdate = (variableIndex) => {
    const updatedDataset1 = [...sampledataset2];
    const updatedDataset2 = [...originalset2];
    let arr1 = [...addminuspercentagelb];
    let arr2 = [...addminuspercentageub];

    // Avoid division by zero
    const isMaintainObjective = objective === "Maintain Spends to Maximize Sales" || objective === "Maintain Sales and Minimize Spends";

    const lowerLimitBase = originalsetublboriginal[variableIndex].a_point || 1;
    const upperKey = isMaintainObjective ? "c_point" : "d_point";

    const upperLimitBase = originalsetublboriginal[variableIndex][upperKey] || 1;

    // Calculate percentage changes
    let percentageChangelb = ((updatedDataset1[variableIndex].lower_limit - originalsetublboriginal[variableIndex].lower_limit) / lowerLimitBase) * 100;

    let percentageChangeub = ((updatedDataset1[variableIndex][upperKey] - originalsetublboriginal[variableIndex][upperKey]) / upperLimitBase) * 100;

    // Ensure finite values and format
    percentageChangelb = isFinite(percentageChangelb) ? percentageChangelb.toFixed(0) : 0;
    percentageChangeub = isFinite(percentageChangeub) ? percentageChangeub.toFixed(0) : 0;


    if (
      percentageChangelb <= 25 &&
      percentageChangelb >= -25 &&
      percentageChangeub <= 25 &&
      percentageChangeub >= -25
    ) {
      const isMaintainObjective = objective === "Maintain Spends to Maximize Sales" || objective === "Maintain Sales and Minimize Spends";
      const lowerBound = updatedDataset1[variableIndex].a_point;
      const comparePoint = isMaintainObjective ? updatedDataset1[variableIndex].c_point : updatedDataset1[variableIndex].d_point;

      if (Number(lowerBound) > Number(comparePoint)) {
        dispatch(
          getNotification({
            message: `Upper Bound is less than lower bound!`,
            type: "danger",
          })
        );
      } else {
        // ✅ Common success logic
        arr1[variableIndex] = percentageChangelb;
        arr2[variableIndex] = percentageChangeub;
        setaddminuspercentagelb(arr1);
        setaddminuspercentageub(arr2);

        if (isMaintainObjective) {
          updatedDataset2[variableIndex].c_point =
            updatedDataset1[variableIndex].c_point;
        } else {
          updatedDataset2[variableIndex].d_point =
            updatedDataset1[variableIndex].d_point;
        }

        updatedDataset2[variableIndex].a_point =
          updatedDataset1[variableIndex].a_point;

        edit[variableIndex] = false;
        handleoriginaldataset2change(updatedDataset2);

        dispatch(
          getNotification({
            message: `Bounds updated for ${updatedDataset2[variableIndex].variables}`,
            type: "success",
          })
        );
      }

    }

    else if (
      percentageChangelb > 25 ||
      percentageChangelb < -25 ||
      percentageChangeub > 25 ||
      percentageChangeub < -25
    ) {
      let confirmedbounds = window.confirm("Entered change percentage is not within -25% to 25% range.Do you wish to continue?")
      if (confirmedbounds) {
        const isMaintainObjective = objective === "Maintain Spends to Maximize Sales" || objective === "Maintain Sales and Minimize Spends";

        const lowerBound = updatedDataset1[variableIndex].a_point;
        const comparePoint = isMaintainObjective ? updatedDataset1[variableIndex].c_point : updatedDataset1[variableIndex].d_point;

        if (Number(lowerBound) > Number(comparePoint)) {
          dispatch(
            getNotification({
              message: `Upper Bound is less than lower bound!`,
              type: "danger",
            })
          );
          return;
        }

        // ✅ Common success logic
        arr1[variableIndex] = percentageChangelb;
        arr2[variableIndex] = percentageChangeub;
        setaddminuspercentagelb(arr1);
        setaddminuspercentageub(arr2);

        if (isMaintainObjective) {
          updatedDataset2[variableIndex].c_point = updatedDataset1[variableIndex].c_point;
        } else {
          updatedDataset2[variableIndex].d_point = updatedDataset1[variableIndex].d_point;
        }

        updatedDataset2[variableIndex].a_point = updatedDataset1[variableIndex].a_point;

        edit[variableIndex] = false;
        handleoriginaldataset2change(updatedDataset2);

        dispatch(
          getNotification({
            message: `Bounds updated for ${updatedDataset2[variableIndex].variables}`,
            type: "success",
          })
        );
      }

    }
  };

  return (
    <div className="accordion mt-3" id="boundsAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="boundHeading">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#boundCollapse"
            aria-expanded="true"
            aria-controls="boundCollapse"
          >
            <strong>Upper Bounds and Lower Bounds</strong>
          </button>
        </h2>
        <div
          id="boundCollapse"
          className="accordion-collapse collapse show"
          aria-labelledby="boundHeading"
          data-bs-parent="#boundsAccordion"
        >
          <div className="accordion-body">
            <div className="table-responsive scrollable-table-container">
              <table className="table table-striped table-bordered mb-0 scrollable-table">
                <thead className="bg-secondary text-white">
                  <tr>
                    <th>Attribute</th>
                    <th>Lower Bound (Weekly)</th>
                    <th>Upper Bound (Weekly)</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {sampledataset2?.map((item, variableIndex) => {
                    const isHidden = hidingvariablelist.some((variable) => variable === item.variables);

                    if (isHidden) return null;

                    return (
                      <tr key={`row-${variableIndex}`}>
                        <td>
                          <b>{item.variables}</b> ({item.type})
                        </td>
                        <td>
                          <div className="d-flex  justify-content-between">
                            <span className="">
                              {edit[variableIndex] ?
                                <div className='d-flex flex-column  w-50'> <small>Bound</small>
                                  <input
                                    className="p-1 my-auto"
                                    placeholder="Lower Limit"
                                    value={
                                      (objective === 'Maintain Spends to Maximize Sales' ||
                                        objective === 'Maintain Sales and Minimize Spends'
                                      )
                                        ?
                                        (item.a_point)
                                        :
                                        (item.a_point)
                                    }
                                    onChange={(e) => table2edit(e, variableIndex, "lb")}
                                    style={{ fontSize: "0.7rem" }}
                                  /></div> :
                                <span>
                                  {
                                    (objective === 'Maintain Spends to Maximize Sales' ||
                                      objective === 'Maintain Sales and Minimize Spends'
                                    )
                                      ?
                                      Number(item.a_point)?.toFixed(2)
                                      :
                                      Number(item.a_point)?.toFixed(2)
                                  }
                                </span>
                              }
                            </span>
                            {edit[variableIndex] && (
                              <div className="d-flex flex-column  w-50">
                                <small>Percentage Change</small>
                                <input
                                  className="p-1 my-auto"
                                  type="number"
                                  placeholder="% increase/decrease"
                                  value={addminuspercentagelb[variableIndex]}
                                  onChange={(e) => table2editpercetnagebasis(e, variableIndex, "lb")}
                                  style={{ fontSize: "0.7rem" }}
                                />

                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="d-flex  justify-content-between">
                            <span className="">
                              {edit[variableIndex] ?
                                <div className='d-flex flex-column  w-50'> <small>Bound</small>
                                  <input
                                    className="p-1 my-auto"
                                    placeholder="Upper Limit"
                                    value={
                                      (objective === 'Maintain Spends to Maximize Sales' ||
                                        objective === 'Maintain Sales and Minimize Spends'
                                      )
                                        ?
                                        (item.c_point)
                                        :
                                        (item.d_point)
                                    }
                                    onChange={(e) => table2edit(e, variableIndex, "ub")}
                                    style={{ fontSize: "0.7rem" }}
                                  /></div> :
                                <span>
                                  {
                                    (objective === 'Maintain Spends to Maximize Sales' ||
                                      objective === 'Maintain Sales and Minimize Spends'
                                    )
                                      ?
                                      Number(item.c_point)?.toFixed(2)
                                      :
                                      Number(item.d_point)?.toFixed(2)
                                  }
                                </span>
                              }
                            </span>
                            {edit[variableIndex] && (
                              <div className="d-flex flex-column  w-50">
                                <small>Percentage Change</small>
                                <input
                                  className="p-1 my-auto"
                                  type="number"
                                  placeholder="% increase/decrease"
                                  value={addminuspercentageub[variableIndex]}
                                  onChange={(e) => table2editpercetnagebasis(e, variableIndex, "ub")}
                                  style={{ fontSize: "0.7rem" }}
                                />

                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          {edit[variableIndex] ? (
                            <div className="d-flex align-items-center">
                              <button
                                className="btn btn-sm checktickbtn"
                                onClick={() => {
                                  handleupdate(variableIndex)
                                }}
                              >
                                <i
                                  className="fa fa-check"
                                  style={{ color: "green", fontSize: "16px" }}
                                ></i>
                              </button>
                              <button
                                className="btn btn-sm"
                                onClick={() => {
                                  let arr = [];
                                  setedit(arr);
                                  handlecancel(variableIndex);
                                }}
                              >
                                <i
                                  className="fa fa-arrow-circle-left greentheme"
                                  style={{ fontSize: "16px" }}
                                ></i>
                              </button>
                            </div>
                          ) : (
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                let arr = [];
                                arr[variableIndex] = true;
                                setedit(arr);
                              }}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UbLbTable